import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  RestoreBackupByActivityRequestProps,
  RestoreBackupByActivityResponse
} from "./types";

export const restoreBackupByActivityRequest = ({
  projectId,
  activityId
}: RestoreBackupByActivityRequestProps) =>
  apiProxyRequest<RestoreBackupByActivityResponse>(
    `/projects/${projectId}/activities/${activityId}/restore`,
    "POST"
  );
